import React from "react";
import styled from "@emotion/styled";
import colabo from "images/collabo.png";
import innovative from "images/innovative.png";
import impact from "images/impact.png";

const Section = styled.div`
  margin: 50px 0 50px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  margin: 0 30px 60px;

  @media (max-width: 1300px) {
    flex: 1;
    margin: 0 10px 60px;
    margin-bottom: 100px;
  }
`;

const Rect1 = styled.div`
  margin: 10px;
  padding: 5px;
  position: relative;
  width: 320px;
  height: 300px;
  border-radius: 5px;
  flex-direction: column;
  text-align: left
  font-size: 24px;
  z-index: 1;

  @media (max-width: 480px) {
    width: 305px;
    height: 285px;
  }
`;

const Rect2 = styled.div`
  margin: 0px 10px;
  padding: 5px 10px;
  width: 320px;
  height: 300px;
  border-radius: 5px;
  flex-direction: column;
  text-align: left;
  font-size: 14px;
  background: #ffffff;
  z-index: 2;

  @media (max-width: 480px) {
    width: 305px;
    height: 285px;
  }
`;

const Header = styled.div`
  font-size: 24px;
  margin: 0 15px 5px;
  line-height: 39px;
`;

const Content = styled.div`
  margin: 10px 10px;
  font-size: 13px;
  line-height: 22px;
  color: #000000;
`;

const Title = styled.h3`
  font-family: ${props => props.theme.fonts.subheading};
  text-align: center;
  text-transform: none;
  margin-top: 0;
  margin-bottom: 70px;
  width: 100%;
`;

const Collabo = styled.img`
  position: absolute;
  z-index: 2;
  left: 175px;
  bottom: 240px;

  @media (max-width: 480px) {
    left: 160px;
    bottom: 225px;
  }
`;

const Innovative = styled.img`
  position: absolute;
  z-index: 2;
  left: 180px;
  bottom: 223px;

  @media (max-width: 480px) {
    left: 165px;
    bottom: 207px;
  }
}
`;

const Impactful = styled.img`
  position: absolute;
  z-index: 2;
  left: 175px;
  bottom: 240px;

  @media (max-width: 480px) {
    left: 150px;
    bottom: 225px;
  }
}
`;

export default function ValuesSection() {
  return (
    <Section>
      <Title>VALUES</Title>
      <Flex>
        <Column>
          <Rect1 css={{ background: "#d40f37" }}>
            <Header>
              <b>Collaborative</b>
            </Header>
            <Collabo src={colabo} />
            <Rect2>
              <Content>
                Berbeda dengan acara IT profesional, COMPFEST memiliki beberapa
                keterbatasan pada berbagai aspek yang ada. Namun, keterbatasan
                ini bukan merupakan suatu halangan untuk mewujudkan visi dari
                COMPFEST. Melalui kolaborasi dari berbagai pihak internal dan
                eksternal diharapkan COMPFEST dapat mewujudkan tujuannya serta
                dapat membuat nama COMPFEST dikenal lebih luas dan memberikan
                lebih banyak manfaat untuk masyarakat Indonesia.
              </Content>
            </Rect2>
          </Rect1>
        </Column>
        <Column>
          <Rect1 css={{ background: "#CE3196" }}>
            <Header>
              <b>Innovative</b>
            </Header>
            <Innovative src={innovative} />
            <Rect2>
              <Content>
                Perubahan merupakan hal yang wajar terjadi, hal tersebut
                dikarenakan kita harus menjadi pribadi yang dinamis. Oleh karena
                itulah inovasi dibutuhkan. Meskipun banyak hal yang tercipta,
                namun masih ada hal yang dapat dikembangkan untuk dapat memberi
                manfaat lebih. Lewat membawa nilai ini, COMPFEST diharapkan
                dapat membawa suatu inovasi yang akan berguna bagi masyarakat
                serta mendorong berbagai sektor untuk terus berkembang.
              </Content>
            </Rect2>
          </Rect1>
        </Column>
        <Column>
          <Rect1 css={{ background: "#F26D0F" }}>
            <Header>
              <b>Impactful</b>
            </Header>
            <Impactful src={impact} />
            <Rect2>
              <Content>
                COMPFEST memiliki tujuan yang salah satunya memberikan dampak
                dan menjadi faktor dalam perkembangan bidang Teknologi Informasi
                di Indonesia. COMPFEST diharapkan dapat memberikan dampak
                positif, baik secara langsung, maupun tidak langsung, yang akan
                berguna untuk masyarakat luas.
              </Content>
            </Rect2>
          </Rect1>
        </Column>
      </Flex>
    </Section>
  );
}
